import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dossier-historique-new",
  templateUrl: "./dossier-historique-new.component.html",
  styleUrls: ["./dossier-historique-new.component.scss"],
})
export class DossierHistoriqueNewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
